module.exports = __webpack_public_path__ + "static/llamame-06cd22aa988c0e543ab7bba1eb729fea.svg";